import { createAsyncThunk } from '@reduxjs/toolkit';
import { getEntryByContentTypeUrl, getPromotionBanner, getMultiplePopupBanner } from '@/services/contentstack';
import {
  changeHomePage,
  changePromotionBanner,
  changePopupBanner,
  getHomePageSuccess,
  changeLanguage
} from '@/store/slices/homePageSlice';
import { ECOM_PROMOTIONS, HOME_PAGE_CONTENT_TYPE, HOME_PAGE_URL, SHARED_BANNER_MODAL } from '@/constants/homePage';
import Stack from '@/contentstack-sdk';

const includeReference = [
  'body.banner.banner_reference',
  'body.featured_post.blog_post',
  'body.featured_post.blog_post.blog_snippet.category',
  'body.featured_post.blog_post.blog_snippet.topic_tags',
  'body.featured_post.blog_post.blog_snippet.product_tags',
  'body.category_cards.categories',
  'body.category_cards.categories.category_reference',
  'body.search_bar.hot_topics',
  'body.banner.banner_reference',
];

const otherReference = [
  'body.verticle_blog_list.blog_post',
  'body.verticle_blog_list.blog_post.blog_snippet.category',
  'body.verticle_blog_list.blog_post.blog_snippet.category.category_reference',
  'body.verticle_blog_list.blog_post.blog_snippet.topic_tags',
  'body.verticle_blog_list.blog_post.blog_snippet.product_tags',
  'latestArticles.blog_snippet.category',
  'latestArticles.blog_snippet.category.category_reference',
  'latestArticles.blog_snippet.topic_tags',
  'latestArticles.blog_snippet.product_tags'
]

export const getHomePageAction = createAsyncThunk(
  'homePage/getHomePageAction',
  async (localLanguage: string, { dispatch, getState }) => {

    const result = await getEntryByContentTypeUrl(HOME_PAGE_CONTENT_TYPE, HOME_PAGE_URL, [...includeReference, ...otherReference, ], localLanguage);
    const data = result?.data[0][0];
    if (!data) return;

    const body = data.body
    dispatch(changeHomePage(data || {}));
    dispatch(getHomePageSuccess(body))
  }
);


export const getPromotionBannerAction = createAsyncThunk(
  'promotionBanner/getPromotionBannerAction',
  async (requestData: any, { dispatch }) => {
    const { pathname, language } = requestData;
    const response = await getPromotionBanner(pathname, language);
    if (!response || !response.data) {
      return { isSuccess: false };
    }
    const promotionBanner = response.data[0] ? response.data[0] : null;
    dispatch(changePromotionBanner(promotionBanner));
    return { isSuccess: true };
  },
);

export const getPopupBannerAction = createAsyncThunk(
  'popupBanner/getPopupBannerAction',
  async (requestData: any, { dispatch }) => {
    const { pathname, language } = requestData
    const { data } = await getMultiplePopupBanner( pathname, language);
    const popupBanner = data[0] && data[0][0] ? data[0][0] : null;
    dispatch(changePopupBanner(popupBanner));
    return { isSuccess: true };
  }
)

export const changLanguageAction = createAsyncThunk(
  'language/changLanguageAction',
  async ({ language }: any, { dispatch }) => {
    const localLanguage = dispatch(changeLanguage(language))
    return localLanguage
  }
)

export const getHomePageLivePreviewAction = createAsyncThunk(
  'homePage/getHomePageLivePreviewAction',
  async (livePreview: any, { dispatch, getState }) => {

    const { content_type_uid, entry_uid } = livePreview;
    let referenceFieldPath: string[] = [];
    if (content_type_uid === HOME_PAGE_CONTENT_TYPE) {
      referenceFieldPath = includeReference
    }
    const result = await Stack.getEntryByLivePreview({
      contentTypeUid: content_type_uid,
      entryUid: entry_uid,
      referenceFieldPath,
    })

    dispatch(getHomePageSuccess(result.body));
  }
)
